module.exports = __webpack_public_path__ + "static/media/Levin_Range_Corner.cd3b48d3.jpg";